import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LeadFunnelProps = {
	leadFunnelStandaloneUrl?: string | null;
};

const initialState: LeadFunnelProps = {
	leadFunnelStandaloneUrl: undefined,
};

const leadFunnelSlice = createSlice({
	name: 'leadFunnelSlice',
	initialState,
	reducers: {
		initLeadFunnelUrl(state, { payload }: PayloadAction<LeadFunnelProps>) {
			return payload;
		},
	},
});

export const leadFunnelSliceActions = leadFunnelSlice.actions;
export default leadFunnelSlice.reducer;
